// extracted by mini-css-extract-plugin
export var arrow = "hy_dm";
export var container = "hy_f";
export var contentWrapper = "hy_qx";
export var description = "hy_c";
export var descriptionLink = "hy_qy";
export var image = "hy_fS";
export var innerContainer = "hy_fz";
export var link = "hy_b5";
export var text = "hy_dt";
export var title = "hy_b";